import { reject, propEq } from 'ramda'
const bankValidators = require('us-bank-account-validator')

class DirectDepositController {
  ADDITIONAL_VALID_ROUTING_NUMBERS = []
  INVALID_ROUTING_NUMBER = '000000000'

  /* @ngInject */
  constructor (UsersService, PayrollService, $scope, $mdToast) {
    this.UsersService = UsersService
    this.PayrollService = PayrollService
    this.$scope = $scope
    this.$mdToast = $mdToast

    this.routingNumberValid = true

    this.searchQuery = ''
    this.selectedWorker = null
    this.directDepositInfo = {
      bankName: null,
      accountType: null,
      routingNumber: null,
      accountNumber: null
    }
    this.foundUsers = []
    this.UserSearch = this.UsersService.userSearch()
    this.UserSearch.on('result', results => {
      this.foundUsers = results.hits.map(user => {
        user.displayValue = `${user.first_name} ${user.last_name} (${user.username})`
        return user
      })
    })
    this.UserSearch.setQuery('')

    this.failedPayments = []
    this.pendingPayments = []
  }

  getFailedPayments () {
    this.PayrollService.getFailedPayments()
    .then(result => {
      this.failedPayments = result
    })
  }

  getPendingPayments () {
    this.pendingPaymentsLoading = true
    this.PayrollService.getPendingPayments()
    .then(result => {
      this.pendingPayments = result
      this.pendingPaymentsLoading = false
    })
  }

  saveDirectDepositInfo () {
    this.validateRoutingNumber()
    if (!this.routingNumberValid) {
      return
    }

    this.PayrollService.saveDirectDepositInfo(this.selectedWorker.id, this.directDepositInfo)
    .then(result => {
      this.directDepositError = ''
      this.$mdToast.showSimple('Direct deposit info saved')

      this.userId = null
      this.directDepositInfo = {
        bankName: null,
        accountType: null,
        routingNumber: null,
        accountNumber: null
      }
      this.selectedWorker = null
      this.$scope.directDepositForm.$setPristine()
      this.$scope.directDepositForm.$setUntouched()
    })
    .catch(response => {
      if (response.status < 500) {
        this.directDepositError = response.data.reason
      } else {
        this.$mdToast.showSimple('Unable to save direct deposit info')
      }
    })
  }

  validateRoutingNumber () {
    this.routingNumberValid = this.isRoutingNumberValid(this.directDepositInfo.routingNumber)
    this.$scope.directDepositForm.routingNumber.$setValidity('', this.routingNumberValid)
  }

  isRoutingNumberValid (routingNumber) {
    const isAdditionalValidNumber = this.ADDITIONAL_VALID_ROUTING_NUMBERS.indexOf(routingNumber) >= 0
    return routingNumber !== this.INVALID_ROUTING_NUMBER &&
      (isAdditionalValidNumber || bankValidators.routingNumber(routingNumber).isValid)
  }

  searchUsers () {
    this.UserSearch.setQuery(this.searchQuery).search()
  }

  reschedulePayment (id, method) {
    this.PayrollService.reschedulePayment(id, method)
    .then(response => {
      this.$mdToast.showSimple('Payment rescheduled')
      this.failedPayments = reject(propEq('paymentStatusId', id), this.failedPayments)
    })
    .catch(response => {
      this.$mdToast.showSimple('Unable to save direct deposit info')
    })
  }
}

export default DirectDepositController
